import { FormBase } from 'core/components';

export default class ProcedureCodeEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'name',
                    label: 'PROCEDURE_CODE.EDIT.NAME_LABEL',
                    placeholder: 'PROCEDURE_CODE.EDIT.NAME_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'description',
                    label: 'PROCEDURE_CODE.EDIT.DESCRIPTION_LABEL',
                    placeholder: 'PROCEDURE_CODE.EDIT.DESCRIPTION_PLACEHOLDER',
                    type: 'textarea',                    
                    rules: 'string'
                }
            ],
        };
    }
}
